import { motion } from "framer-motion";

const CONNECTIONS = [
  {
    imgs: ["/whitehouse-group.jpg", "/whitehouse-selfie.webp"],
    title: "The Obama White House",
    meta: "Phillip and his family at 1600 Pennsylvania Avenue.",
    span: "md:col-span-7",
    offset: "",
  },
  {
    img: "/prague-torvalds.webp",
    title: "Linus Torvalds",
    meta: "With the creator of Linux and Phillip's daughter Keila at Open Source Summit Europe.",
    span: "md:col-span-5",
    offset: "md:mt-24",
  },
  {
    imgs: ["/garcetti-event.png", "/garcetti-outdoor.jpg"],
    title: "City of Los Angeles",
    meta: "Technology education and youth initiatives.",
    span: "md:col-span-7",
    offset: "md:-mt-16",
  },
  {
    img: "/mayor-brown.webp",
    title: "City of Compton",
    meta: "Community technology work.",
    span: "md:col-span-5",
    offset: "md:mt-12",
  },
  {
    img: "/tedx-inglewood.jpg",
    title: "TEDx Inglewood",
    meta: "Founding leadership.",
    span: "md:col-span-7",
    offset: "md:-mt-16",
  },
  {
    img: "/black-boys-code.jpg",
    title: "Black Boys Code",
    meta: "Los Angeles Chapter President.",
    span: "md:col-span-5",
    offset: "md:mt-24",
  },
  {
    img: "/scale.jpg",
    title: "Southern California Linux Expo",
    meta: "More than two decades helping lead one of the largest community-run open source conferences in North America.",
    span: "md:col-span-7",
    offset: "md:-mt-16",
  },
];

export default function Connections() {
  return (
    <section id="connections" data-testid="connections-section" className="py-32 lg:py-40 bg-muted/60">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.p initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, ease: "easeOut" }} className="text-xs md:text-sm tracking-[0.25em] uppercase font-bold text-accent">
          Leadership & Community
        </motion.p>
        <motion.h2 initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, delay: 0.1, ease: "easeOut" }} className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none mt-6 max-w-3xl">
          Technology has always been <span className="italic text-primary">about people.</span>
        </motion.h2>
        <motion.p initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, delay: 0.15, ease: "easeOut" }} className="mt-8 max-w-2xl text-base sm:text-lg leading-relaxed font-light text-foreground/80">
          Phillip's work has connected him with leaders across technology,
          government, education, business, and community organizations.
        </motion.p>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-12 gap-10">
          {CONNECTIONS.map((c, i) => (
            <motion.figure
              key={c.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: (i % 2) * 0.1, ease: "easeOut" }}
              data-testid={`connection-card-${i}`}
              className={`${c.span} ${c.offset} group`}
            >
              {c.imgs ? (
                <div className="grid grid-cols-2 gap-4">
                  {c.imgs.map((src) => (
                    <div key={src} className="overflow-hidden rounded-xl border border-[#D8D4CA]">
                      <img
                        src={src}
                        alt={c.title}
                        loading="lazy"
                        className="w-full aspect-[3/4] object-cover object-top group-hover:scale-105 transition-transform duration-700 ease-out"
                      />
                    </div>
                  ))}
                </div>
              ) : (
                <div className="overflow-hidden rounded-xl border border-[#D8D4CA]">
                  <img
                    src={c.img}
                    alt={c.title}
                    loading="lazy"
                    className="w-full aspect-[4/3] object-cover object-top group-hover:scale-105 transition-transform duration-700 ease-out"
                  />
                </div>
              )}
              <figcaption className="mt-5 flex items-baseline justify-between gap-4">
                <div>
                  <div className="font-display text-2xl tracking-tight">{c.title}</div>
                  <div className="text-sm text-foreground/60 mt-1">{c.meta}</div>
                </div>
                <span className="font-display text-xl text-primary/70 shrink-0">0{i + 1}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
